import React from "react";
import { PriceQuoteRowProps } from "interfaces/payment_modal.interface";
import "./price_quote_row.component.scss";

// One target in the order summary: which target it is, its video if it has one, and what it costs.
const PriceQuoteRow = (props: PriceQuoteRowProps): React.ReactElement => (
    <div className="price_quote_row">
        <div className="price_quote_row_thumb">
            {props.imageUrl && <img src={props.imageUrl} alt={props.imageAlt} />}
        </div>
        <div className="price_quote_row_text">
            <div className="price_quote_row_label">{props.label}</div>
            {props.details && props.details.length > 0 && (
                <div className="price_quote_row_detail">{props.details.join(' · ')}</div>
            )}
        </div>
        <div className="price_quote_row_amount">{props.amount}</div>
    </div>
);

export default PriceQuoteRow;
